import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import {
  PopoverAnchor,
  Popover,
  PopoverContent,
  SelectInput,
  TextInput,
} from "..";

export default function SingleFilter({
  value,
  onChange,
  onDelete,
  fields = [],
}) {
  const [openPopOver, setOpenPopOver] = useState(false);

  const getOperatorOptions = (fieldType) => {
    switch (fieldType) {
      case "text":
      case "link":
      case "richtext":
      case "option":
        return [
          { label: "Equals", value: "equals" },
          { label: "Contains", value: "contains" },
          { label: "Starts With", value: "startsWith" },
          { label: "Ends With", value: "endsWith" },
          { label: "Is Set", value: "isSet" },
          { label: "Is Not Set", value: "isNotSet" },
        ];
      case "switch":
        return [
          { label: "Is True", value: "isTrue" },
          { label: "Is False", value: "isFalse" },
        ];
      case "image":
        return [
          { label: "Is Set", value: "isSet" },
          { label: "Is Not Set", value: "isNotSet" },
        ];
      case "datetime":
        return [
          { label: "After", value: "after" },
          { label: "Before", value: "before" },
        ];
      default:
        return [
          { label: "Equals", value: "equals" },
          { label: "Contains", value: "contains" },
        ];
    }
  };

  const selectedField = fields.find((f) => f.id === value.field);
  const fieldType = selectedField?.type || "text";
  const operatorOptions = getOperatorOptions(fieldType);

  const shouldShowValueInput = () => {
    // Hide for these operators
    if (["isSet", "isNotSet", "isTrue", "isFalse"].includes(value.operator)) {
      return false;
    }
    return true;
  };

  const renderValueInput = () => {
    if (!shouldShowValueInput()) return null;

    if (
      fieldType === "datetime" &&
      ["after", "before"].includes(value.operator)
    ) {
      return (
        <div className="flex flex-col gap-2">
          <div>
            <label className="text-xs mb-1 block">Date</label>
            <input
              type="date"
              className="w-full p-2 rounded border bg-editor-input-selected outline-none"
              value={value.value?.date || ""}
              onChange={(e) => {
                onChange({
                  ...value,
                  value: {
                    ...value.value,
                    date: e.target.value,
                  },
                });
              }}
            />
          </div>
          <div>
            <label className="text-xs mb-1 block">Time</label>
            <input
              type="time"
              className="w-full p-2 rounded border bg-editor-input-selected outline-none"
              value={value.value?.time || ""}
              onChange={(e) => {
                onChange({
                  ...value,
                  value: {
                    ...value.value,
                    time: e.target.value,
                  },
                });
              }}
            />
          </div>
        </div>
      );
    }

    return (
      <TextInput
        isResetVisible={false}
        value={value.value}
        onChange={(val) => {
          onChange({ ...value, value: val });
        }}
        label="Value"
      />
    );
  };

  const formatDateTime = (value) => {
    if (!value) return "";
    if (fieldType === "datetime" && value.date) {
      const date = new Date(value.date + " " + (value.time || "00:00"));
      return date.toLocaleString();
    }
    return value;
  };

  return (
    <>
      <div className="cursor-default hover:bg-gray-50 p-2">
        <Popover>
          <PopoverAnchor
            placement="bottom"
            open={openPopOver}
            onOpenChange={setOpenPopOver}
          >
            <div className="grigora-singlefilter__anchor flex items-center justify-between gap-2">
              <p>
                {`${selectedField?.label || "Select Field"} ${
                  operatorOptions.find((op) => op.value === value.operator)
                    ?.label || "Equals"
                } ${formatDateTime(value.value)}`}
              </p>
              <div className="flex items-center gap-1">
                <FontAwesomeIcon icon={faPen} className="p-2 cursor-pointer" />
                <FontAwesomeIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete();
                  }}
                  icon={faTrash}
                  className="p-2 cursor-pointer"
                />
              </div>
            </div>
          </PopoverAnchor>
          <PopoverContent className="outline-none !z-[1000] !rounded-[6px] !bg-editor-light-main !shadow-editor-floating-elements">
            <div className="popover__content w-[250px] p-4 border">
              <SelectInput
                isResetVisible={false}
                value={value.field}
                onChange={(val) => {
                  onChange({
                    ...value,
                    field: val,
                    operator: getOperatorOptions(
                      fields.find((f) => f.id === val)?.type || "text",
                    )[0].value,
                  });
                }}
                options={fields.map((field) => ({
                  label: field.label,
                  value: field.id,
                }))}
                label="Field"
              />

              <SelectInput
                isResetVisible={false}
                value={value.operator}
                onChange={(val) => {
                  onChange({ ...value, operator: val });
                }}
                options={operatorOptions}
                label="Operator"
              />

              {renderValueInput()}
            </div>
          </PopoverContent>
        </Popover>
      </div>
    </>
  );
}
